<template>
 <v-row row wrap>

    <v-col cols="12" >
        <v-row justify="space-between">
            <v-col cols="12" sm="6" md="8">
             <!-- FILTERS HERE -->
            </v-col>
            <v-col cols="12" sm="6" md="4">
            <search-input  @search="performSearch" v-model="search" />
            </v-col>
        </v-row>
    </v-col>

    <v-col cols="12">

       <v-data-table
                class="mt-3"
                :headers="headers"
                :items="items"
                :search="search"
                :single-expand="false"
                :server-items-length="totalItems"
                :loading="loading"
                :page.sync="pageNumber"
                :items-per-page.sync="itemsPerPage"
                :sort-by.sync="orderBy"
                :sort-desc.sync="orderDesc"
                :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
                @update:page="fetch"
                @update:sort-by="fetch"
                @update:sort-desc="fetch"
                @update:items-per-page="fetch"
        >

         <template v-slot:item.inactiva="{ item }">
           <div v-if="item.inactiva">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

         <template v-slot:item.cancelaSaldos="{ item }">
           <div v-if="item.cancelaSaldos">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

         <template v-slot:item.cancelaSaldosHistorico="{ item }">
           <div v-if="item.cancelaSaldosHistorico">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

         <template v-slot:item.informarBCRA="{ item }">
           <div v-if="item.informarBCRA">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

         <template v-slot:item.rotacionBloqueada="{ item }">
           <div v-if="item.rotacionBloqueada">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

         <template v-slot:item.noRota="{ item }">
           <div v-if="item.noRota">
             <v-icon color="success">check_circle</v-icon>
           </div>
           <div v-else>
             <v-icon color="error">highlight_off</v-icon>
           </div>
         </template>

            <template slot="no-data">
               <div class="text-xs-center" v-t="'common.noData'"></div>
            </template>

            <template slot="loading">
               <div   class="text-xs-center" v-t="'common.loading'"></div>
            </template>

            <template v-slot:item.action="{ item }">
                <show-button  @click="$emit('show', item)" />
              <edit-button v-if="$store.getters.hasPermission('ESTADODEUDA_UPDATE')"  @click="$emit('update', item)" />
              <delete-button v-if="$store.getters.hasPermission('ESTADODEUDA_DELETE')" @click="$emit('delete', item)" />
            </template>

        </v-data-table>
    </v-col>
</v-row>
</template>

<script>
   import EstadoDeudaProvider from "../../../../providers/EstadoDeudaProvider";

   import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"


    export default {
        name: "EstadoDeudaList",
        components: {DeleteButton, EditButton, ShowButton, SearchInput},

        data() {
            return {
                items: [],
                totalItems: null,
                loading: false,
                orderBy: null,
                orderDesc: false,
                itemsPerPage: 5,
                pageNumber: 1,
                search: '',
                filters: [
                    /*{
                        field: '',
                        operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
                        value: ''
                    }*/
                ]
            }
        },
        computed: {
          headers () {
            return [
                    //Entity Headers
                    {text: this.$t('cobrox.estadoDeuda.labels.nombre'), value: 'nombre'},
                    {text: this.$t('cobrox.estadoDeuda.labels.inactiva'), value: 'inactiva', align: 'center'},
                    {text: this.$t('cobrox.estadoDeuda.labels.cancelaSaldos'), value: 'cancelaSaldos', align: 'center'},
                    {text: this.$t('cobrox.estadoDeuda.labels.cancelaSaldosHistorico'), value: 'cancelaSaldosHistorico', align: 'center'},
                    {text: this.$t('cobrox.estadoDeuda.labels.informarBCRA'), value: 'informarBCRA', align: 'center'},
                    {text: this.$t('cobrox.estadoDeuda.labels.rotacionBloqueada'), value: 'rotacionBloqueada', align: 'center'},
                    {text: this.$t('cobrox.estadoDeuda.labels.noRota'), value: 'noRota', align: 'center'},
                    //Actions
                    {text: this.$t('common.actions'), value: 'action', sortable: false},
                ]
          },
          getOrderBy(){
              return  (Array.isArray(this.orderBy)) ? this.orderBy[0]: this.orderBy
          },
          getOrderDesc(){
              return  (Array.isArray(this.orderDesc)) ? this.orderDesc[0]: this.orderDesc
          }
        },
        created() {
            this.fetch()
        },
        methods:{
            performSearch(){
                this.pageNumber = 1
                this.fetch()
            },
            fetch() {
                this.loading = true
                EstadoDeudaProvider.paginateEstadoDeuda(
                    this.pageNumber,
                    this.itemsPerPage,
                    this.search,
                    this.filters,
                    this.getOrderBy,
                    this.getOrderDesc
                ).then(r => {
                    this.items = r.data.paginateEstadoDeuda.items
                    this.totalItems = r.data.paginateEstadoDeuda.totalItems
                }).catch(err => {
                    console.error(err)
                }).finally(() => this.loading = false)
            }
        }

    }
</script>


